var _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDominiumLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 245 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6h12l8 10v14H20L12 20V6Z",
    fill: "none",
    stroke: "#91adff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14h12M20 14v16M12 6l8 8",
    fill: "none",
    stroke: "#91adff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 23,
    fill: "#18263c",
    fontFamily: "Arial,sans-serif",
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: -0.6
  }, "dominium", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 12,
    x: 46,
    y: 38,
    letterSpacing: 3
  }, "CHAT"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDominiumLight);
export default __webpack_public_path__ + "static/media/dominium-light.eafdf4f64d5753aae88b8a8106f4f1bf.svg";
export { ForwardRef as ReactComponent };